// extracted by mini-css-extract-plugin
export default {"addToCartControl":"ZZ-z","giftCard":"_Z-z","btnContainer":"a0-z","cartButton":"b0-z","disabled":"c0-z"};